module.exports = __webpack_public_path__ + "static/02_img_9271-df229a7bea6f071d8be3943d2e7fc242.webp";